/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthConsumeRouteImport } from './routes/auth.consume'
import { Route as AppOnboardingRouteImport } from './routes/_app.onboarding'
import { Route as AppAffiliateRouteImport } from './routes/_app.affiliate'
import { Route as AppInvoicesIndexRouteImport } from './routes/_app.invoices.index'
import { Route as AppInvoicesNewRouteImport } from './routes/_app.invoices.new'
import { Route as AppInvoicesIdRouteImport } from './routes/_app.invoices.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthConsumeRoute = AuthConsumeRouteImport.update({
  id: '/auth/consume',
  path: '/auth/consume',
  getParentRoute: () => rootRouteImport,
} as any)
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AppRoute,
} as any)
const AppAffiliateRoute = AppAffiliateRouteImport.update({
  id: '/affiliate',
  path: '/affiliate',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesIndexRoute = AppInvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesNewRoute = AppInvoicesNewRouteImport.update({
  id: '/invoices/new',
  path: '/invoices/new',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesIdRoute = AppInvoicesIdRouteImport.update({
  id: '/invoices/$id',
  path: '/invoices/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/affiliate': typeof AppAffiliateRoute
  '/onboarding': typeof AppOnboardingRoute
  '/auth/consume': typeof AuthConsumeRoute
  '/invoices/$id': typeof AppInvoicesIdRoute
  '/invoices/new': typeof AppInvoicesNewRoute
  '/invoices/': typeof AppInvoicesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/affiliate': typeof AppAffiliateRoute
  '/onboarding': typeof AppOnboardingRoute
  '/auth/consume': typeof AuthConsumeRoute
  '/invoices/$id': typeof AppInvoicesIdRoute
  '/invoices/new': typeof AppInvoicesNewRoute
  '/invoices': typeof AppInvoicesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/affiliate': typeof AppAffiliateRoute
  '/_app/onboarding': typeof AppOnboardingRoute
  '/auth/consume': typeof AuthConsumeRoute
  '/_app/invoices/$id': typeof AppInvoicesIdRoute
  '/_app/invoices/new': typeof AppInvoicesNewRoute
  '/_app/invoices/': typeof AppInvoicesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/affiliate'
    | '/onboarding'
    | '/auth/consume'
    | '/invoices/$id'
    | '/invoices/new'
    | '/invoices/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/affiliate'
    | '/onboarding'
    | '/auth/consume'
    | '/invoices/$id'
    | '/invoices/new'
    | '/invoices'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/login'
    | '/_app/affiliate'
    | '/_app/onboarding'
    | '/auth/consume'
    | '/_app/invoices/$id'
    | '/_app/invoices/new'
    | '/_app/invoices/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthConsumeRoute: typeof AuthConsumeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/consume': {
      id: '/auth/consume'
      path: '/auth/consume'
      fullPath: '/auth/consume'
      preLoaderRoute: typeof AuthConsumeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/onboarding': {
      id: '/_app/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AppOnboardingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/affiliate': {
      id: '/_app/affiliate'
      path: '/affiliate'
      fullPath: '/affiliate'
      preLoaderRoute: typeof AppAffiliateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices/': {
      id: '/_app/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AppInvoicesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices/new': {
      id: '/_app/invoices/new'
      path: '/invoices/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof AppInvoicesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices/$id': {
      id: '/_app/invoices/$id'
      path: '/invoices/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof AppInvoicesIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAffiliateRoute: typeof AppAffiliateRoute
  AppOnboardingRoute: typeof AppOnboardingRoute
  AppInvoicesIdRoute: typeof AppInvoicesIdRoute
  AppInvoicesNewRoute: typeof AppInvoicesNewRoute
  AppInvoicesIndexRoute: typeof AppInvoicesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAffiliateRoute: AppAffiliateRoute,
  AppOnboardingRoute: AppOnboardingRoute,
  AppInvoicesIdRoute: AppInvoicesIdRoute,
  AppInvoicesNewRoute: AppInvoicesNewRoute,
  AppInvoicesIndexRoute: AppInvoicesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthConsumeRoute: AuthConsumeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
